import './polyfill.ts';
import * as jQuery from 'jquery';
// kendo needs global JQuery, JsZip Object
window['jQuery'] = window['$'] = jQuery;
window["JSZip"] = require("jszip");

import * as angular from 'angular';
import 'angular';
import 'angular-animate';
import 'angular-route';
import 'angular-ui-bootstrap';

import 'ms-signalr-client';

import 'modernizr/modernizr-custom.js';

//#region location of kendo is defined in webpack-config
import "@kendo/kendo.grid.js";
import "@kendo/kendo.panelbar.js";
import "@kendo/kendo.splitter.js";
import "@kendo/kendo.angular.js";
import "@kendo/kendo.button.js";
import "@kendo/kendo.multiselect.js";
import "@kendo/kendo.tooltip.js";
import "@kendo/kendo.autocomplete.js";
import "@kendo/kendo.filtercell.js";
import "@kendo/kendo.tabstrip.js";
import "@kendo/kendo.upload.js";
import "@kendo/kendo.autocomplete.js";
import "@kendo/kendo.colorpicker.js";
import "@kendo/kendo.notification.js";
import "@kendo/kendo.treelist.js";
import "@kendo/kendo.listview.js";
import "@kendo/messages/kendo.messages.de-DE.js";
import "@kendo/cultures/kendo.culture.de-DE.js";
//#endregion

// Apply runtime patches for Kendo UI (must run before app widgets instantiate)
import "./kendo-patches";

// Ensure Inclusion ...
import '../scripts/KWFMain';
import '../scripts/navkendo';
import '../scripts/admin/KWFApplication.Admin';
import '../scripts/userdesk/userdesk';
import '../scripts/PreviewDock';
import '../scripts/editform/rwf3baseservice';
import '../scripts/rwf.desktop';

// For compatibility with global access of namespaces from custom templates
import * as KWFApplication from '../scripts/KWFApplication';
import * as PreviewService from '../scripts/rwfpreview/KWFPreviewService';
import * as kwidgets from '@common/navkendo';
import * as kgrid from '@common/navkendo/navgrid';
import * as _fn from '@common/utils';
import * as KWFMain from '../scripts/KWFMain';
import * as KWFUtils from '../scripts/KWFUtils';
import '../scripts/navdata/navdata';
import * as BenutzerSchreibtisch from '../scripts/userdesk/userdesk';
import * as KWFEditForm from '../scripts/KWFEdit';
import * as sign from '../scripts/infoma.sign';
import { constants } from '../scripts/navkendo';
import { AppInfo } from '@common/app.utils';

window['infoma'] = $.extend(window['infoma'] || {}, {
  fn: _fn.fn,
  kwidgets: $.extend({},  kwidgets, kgrid),
  sign: sign,
  constants: constants
});
window['KWF'] = $.extend(window['KWF'] || {}, BenutzerSchreibtisch, KWFUtils, KWFApplication, PreviewService, {
  BenutzerSchreibtisch: BenutzerSchreibtisch
});
window['KWFMain'] = $.extend(window['KWFMain'] || {}, KWFMain);
window['KWFEditForm'] = $.extend(window['KWFEditForm'] || {}, KWFEditForm);

$(document).ready(() => {
  if (!AppInfo.IsTest) { // do not bootstrap in tests
    angular.bootstrap(document, ["KWFApplication", "RWF.Desktop"], { strictDi: true });
  }
});

//MSQQQ
export class RWFApplication {

}
